module.exports = __webpack_public_path__ + "static/adelle_lightitalic-webfont-woff-c541c667f9f570c97dadb99ab507595c.woff";